import { remainingMs, type FocusState } from './focusMachine';
import { longBreakAfter, MINUTE } from './sessionPlan';

/**
 * When the session will end if every round runs its course: the current
 * phase's time left, then each round and break still to come. `null` for
 * Flow, or with no session under way.
 */
export function sessionEndsAt(state: FocusState, now: number): number | null {
  if (state.mode === 'flow' || state.sessionStartedAt === null) return null;
  const breakAfter = (round: number) =>
    round === longBreakAfter(state.rounds)
      ? state.longMinutes
      : state.shortMinutes;
  const focus = state.focusMinutes * MINUTE;
  let t = now + (state.phase === 'idle' ? 0 : (remainingMs(state, now) ?? 0));
  // The round under way (or the break after `completedRounds`) is counted
  // above; everything after it is added here.
  const running = state.phase === 'focus' || state.phase === 'paused';
  let round = running ? state.completedRounds + 1 : state.completedRounds;
  if (state.phase === 'idle' || state.phase === 'break') {
    // Next: the round after the last one finished.
    round += 1;
    t += focus;
  }
  for (; round < state.rounds; round++) t += breakAfter(round) * MINUTE + focus;
  return t;
}
